import { useSyncExternalStore } from "react";

import { lerPreferencia, gravarPreferencia } from "../services/preferencias";

// Se os botões flutuantes de ligação (telefone do WhatsApp e softphone) ficam
// escondidos. Preferência de quem usa o aparelho: vale até a pessoa mudar, e
// fica no cookie de preferências, como o tema.
const CHAVE = "botoes_ligacao_ocultos";

let ocultos = lerPreferencia(CHAVE, false) === true;
const ouvintes = new Set();

export const definirBotoesOcultos = (valor) => {
	ocultos = Boolean(valor);
	gravarPreferencia(CHAVE, ocultos);
	ouvintes.forEach((o) => o());
};

const assinar = (o) => {
	ouvintes.add(o);
	return () => ouvintes.delete(o);
};

export const useBotoesOcultos = () =>
	useSyncExternalStore(
		assinar,
		() => ocultos,
		() => false,
	);
